/**
 * @fileoverview Interactions of Facebook Events on Linked Accounts page.
 *
 * @author nliang@yext.com
 */
goog.module('yext.storm.linkedaccounts.FacebookEventsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');
const View = goog.require('yext.mvc.View');
/** @suppress {extraRequire} */
goog.require('yext.storm.FolderTree');
const routes = goog.require('yext.storm.routes');

const FacebookEventsView = class extends View {
  /**
   * @param {!jQuery}
   */
  constructor($ctxt) {
    super();

    /** @type{!jQuery} */
    this.$ctxt = $ctxt;

    /** @type {!jQuery} */
    this.$label = $ctxt.find('.js-fb-events-label');

    /** @type{!jQuery} */
    this.$editView = $ctxt.find('.js-fb-events-edit');

    /** @type{!jQuery} */
    this.$folder = $ctxt.find('.js-fb-events-folder-container');

    /** @type{!jQuery} */
    this.$save = $ctxt.find('.js-save');

    /** @type{!jQuery} */
    this.$cancel = $ctxt.find('.js-cancel');

    /** @type{!jQuery} */
    this.$error = $ctxt.find('.js-fb-events-error');

    /** @type{number} */
    this.pageId = $ctxt.data('page-id');

    /**
     * @type {Model}
     * @private
     */
    this.model_ = new Model();

    /**
     * @type {!Object}
     * @private
     */
    this.originalState_ = null;
  }

  /**
   * Initialize interations
   * @public
   */
  init() {
    this.initModel_();
    this.bindModelToRender_();
    this.bindRadioSelection_();
    this.bindEdit_();
    this.bindSave_();

    this.render();
  }

  /**
   * Initialize data model
   * @private
   */
  initModel_() {
    this.model_.init({
      'selection': this.$ctxt.find('.js-default:checked').val(),
      'pageId': this.$ctxt.data('page-id'),
      'folderId': this.$folder.data('folder-id'),
      'initialKeyPath': this.$folder.data('folder-path'),
      'editMode': false,
      'saveEnabled': false,
    });

    this.originalState_ = this.model_.raw();
  }

  /** @private */
  bindModelToRender_() {
    this.model_.on('reset', function() {
      this.render();
      this.toggleEdit_();
    }.bind(this));

    this.model_.on('change:selection', function() {
      this.render();
    }.bind(this));

    this.model_.on('change:editMode', function() {
      this.toggleEdit_();
    }.bind(this));

    this.model_.on('change:saveEnabled', function() {
      this.toggleSave_();
    }.bind(this));
  }

  /**
   * Initialize radio selection
   * @private
   */
  bindRadioSelection_() {
    this.$ctxt.find('.js-default').on('change', function(e) {
      var selection = $(e.target).val();
      this.model_.set({
        'selection': selection,
        'folderId': selection === 'folder' ? this.model_.get('folderId') : null,
        'folderName': selection === 'folderName' ? this.model_.get('folderName') : null,
        'saveEnabled': true,
      });
    }.bind(this));
  }

  /**
   * Initialzie save
   * @private
   */
  bindSave_() {
    this.$ctxt.on('click', '.js-save', function() {
      $.ajax({
        'url': routes.LinkedAccounts.facebookEventsDefault(),
        'type': 'POST',
        'data': this.model_.raw(),
      })
        .success(function() {
          this.model_.set('editMode', false);
          this.originalState_ = this.model_.raw();
          this.updateLabel_();
          this.$error.hide();
        }.bind(this))
        .error(function() {
          this.$error
            .show()
            .html(yext.msg('Failed to save default option'));
        }.bind(this));
    }.bind(this));
  }

  /**
   * Initialzie toggle edit mode
   */
  bindEdit_() {
    this.$ctxt.on('click', '.js-edit-link', function() {
      this.model_.set('editMode', true);
    }.bind(this));

    this.$ctxt.on('click', '.js-cancel', function() {
      this.model_.resetState(this.originalState_);
    }.bind(this));
  }

  /**
   * Prepares folder tree
   * @private
   */
  setupTree_() {
    this.$folder.simpleFolderTree({
      'topLevelFolders': window.topLevelFolders,
      'initialKeyPath': this.model_.get('initialKeyPath'),
      'idPrefix': 'fb-events-folder-tree-id-',
      'onActivate': function(node) {
        this.model_.set({
          'folderId': node.data.key,
          'folderName': node.data.title,
          'saveEnabled': node.data.key != this.model_.get('folderId'),
        });
      }.bind(this),
    });
  }

  /** @override */
  render() {
    if (this.model_.get('selection') === 'folder') {
      this.setupTree_();
    } else {
      this.$folder.hide();
    }
  }

  /** @private */
  toggleEdit_() {
    this.$editView.toggle(this.model_.get('editMode'));
  }

  /** @private */
  toggleSave_() {
    if (this.model_.get('saveEnabled')) {
      this.$save.removeAttr('disabled');
    }
  }

  /** @private */
  updateLabel_() {
    var html;
    switch (this.model_.get('selection')) {
      case 'noDefault':
        html = yext.msg('(Not a default <a class="js-edit-link">edit defaults</a>)');
        break;
      case 'all':
        html = yext.msg('(Default for All Events <a class="js-edit-link">edit defaults</a>)');
        break;
      case 'folder':
        html = yext.msg(
          '(Default for Folder: {0} <a class="js-edit-link">edit defaults</a>)',
          this.model_.get('folderName'));
        break;
    }
    this.$label.html(html);
  }
};

goog.exportSymbol('yext.storm.linkedaccounts.FacebookEventsView', FacebookEventsView);

exports = FacebookEventsView;
